'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text) {
  var hashtagsOnly = [];
  var hashtagsWithIndices = (0, _extractHashtagsWithIndices2.default)(text);
  for (var i = 0; i < hashtagsWithIndices.length; i++) {
    hashtagsOnly.push(hashtagsWithIndices[i].hashtag);
  }

  return hashtagsOnly;
};

var _extractHashtagsWithIndices = require('./extractHashtagsWithIndices');

var _extractHashtagsWithIndices2 = _interopRequireDefault(_extractHashtagsWithIndices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];